import { Section, H2, DataField } from "../../components/common-components";
import { formatDateToDDMMYYYY, formatTimeFromISO } from "../../../../helpers/functions";
import { stripHtmlToPlainText } from "../../../../helpers/interventionHtml";

export const LabInformation = ({ formType, pharmacistFollowUp = {} }) => {
    const {
        laboratoryRecommendations = "",
        suggestedLabDateTime = "",
        reasonsForLab = [],
        pharmacistRecommendations = "",
    } = pharmacistFollowUp || {};

    const labReasonsOptions = [
        { value: "Monitor Drug Therapy / Effectiveness of Therapy", label: "Monitor Drug Therapy / Effectiveness of Therapy" },
        { value: "Monitor Drug Interactions / Levels", label: "Monitor Drug Interactions / Levels" },
        { value: "Monitor Disease / Chronic Conditions", label: "Monitor Disease / Chronic Conditions" },
        { value: "Determine Risk Status for Disease / Conditions", label: "Determine Risk Status for Disease / Conditions" },
    ];

    const suggestedLabDateTimeValid =
        suggestedLabDateTime != null &&
        suggestedLabDateTime !== "" &&
        !Number.isNaN(new Date(suggestedLabDateTime).getTime());

    const suggestedLabDateDisplay = suggestedLabDateTimeValid
        ? formatDateToDDMMYYYY(suggestedLabDateTime)
        : "";
    const suggestedLabTimeDisplay = formatTimeFromISO(
        suggestedLabDateTime != null ? String(suggestedLabDateTime) : ""
    );
    const hasLaboratoryRecommendations = !!laboratoryRecommendations?.toString?.().trim();
    const hasSuggestedLabDateOrTime =
        !!suggestedLabDateDisplay?.toString?.().trim() || !!suggestedLabTimeDisplay?.toString?.().trim();
    const hasReasonsForLab = Array.isArray(reasonsForLab) && reasonsForLab.length > 0;
    const hasPharmacistRecommendations = !!pharmacistRecommendations?.toString?.().trim();

    const hasAnyLabValues =
        hasLaboratoryRecommendations ||
        hasSuggestedLabDateOrTime ||
        hasReasonsForLab ||
        hasPharmacistRecommendations;

    if (!hasAnyLabValues) {
        return (
            <Section formType={formType}>
                <H2>Lab Information - No lab suggestions provided </H2>
            </Section>
        );
    }

    return (
        <Section formType={formType}>
            <H2>Lab Information</H2>
            <div className="space-y-2">
                {(hasLaboratoryRecommendations || hasSuggestedLabDateOrTime) && (
                    <div className="flex space-x-2">
                        {hasLaboratoryRecommendations && (
                            <div className="w-[343px] h-[50px] bg-white text-teal-300 border border-gray-100 p-2">
                                <DataField label="Laboratory Recommendations" vertical={true} value={laboratoryRecommendations || ""} />
                            </div>
                        )}

                        {hasSuggestedLabDateOrTime && (
                            <div className="w-[359px] h-[50px] bg-white text-teal-300 border border-gray-100 flex flex-nowrap items-start p-2 gap-8 min-w-0">
                                <DataField
                                    label="Suggested Lab Date"
                                    vertical={true}
                                    value={suggestedLabDateDisplay}
                                    noWrapLabel
                                    noWrapValue
                                    className="min-w-0 shrink"
                                />
                                <div className="w-px shrink-0 self-stretch min-h-[30px] bg-gray-100"></div>
                                <DataField
                                    label="Suggested Lab Time"
                                    vertical={true}
                                    value={suggestedLabTimeDisplay}
                                    noWrapLabel
                                    noWrapValue
                                    className="min-w-0 shrink"
                                />
                            </div>
                        )}
                    </div>
                )}

                {hasReasonsForLab && (
                    <div className="space-y-3">
                        <div className="font-semibold text-teal-300 text-[14px]">Reason(s) for lab</div>
                        <div className="grid grid-cols-2 gap-2">
                            {labReasonsOptions
                                .filter((opt) => reasonsForLab && reasonsForLab.includes(opt.value))
                                .map((opt) => (
                                    <DataField key={opt.value} label={opt.label} value={opt.label} />
                                ))}
                        </div>
                    </div>
                )}

                {hasPharmacistRecommendations && (
                    <div className="bg-white border border-gray-100 text-teal-300 font-semibold text-md p-2 max-h-32 ">
                        <DataField
                            label="Lab Suggestions (Optional)"
                            vertical={true}
                            value={stripHtmlToPlainText(pharmacistRecommendations || "")}
                        />
                    </div>
                )}
            </div>
        </Section>
    )
}